import isElement from '../../scripts/util/isElement';
import question from '../support/question';
import popup from '../support-category/popup';
import isMobile from 'ismobilejs';
import $ from 'jquery';

const selectors = {
	sectionQuestion: '.price__add-question',
	promo: {
		section: '.price__promo',
		input: '.promo-form__input-wrap .js-field-input',
		link: '.price__promo-greeting-link',
		form: '.promo-form',
		errors: '.price__promo-form__errors',
		wrap: '.price__promo-form',
		apply: '.price__promo-apply-complete'
	},
	card: {
		item: '.card-rates__item-list',
		tooltip: '.card-rates__item-list-tooltip',
		tariff: '.card-rates__button-choose-active'
	},
	order: {
		form: '.js-signup-form__with-page',
		inputs: '.js-signup-form__with-page .js-field-input',
		errors: '.signup-form__errors',
		submit: '.js-sign-up-button-submit',
		preloader: '.signup-form__preloader',
		withoutTariff: '.js-signup-form-header-without-tariff'
	}
};

const classes = {
	promoFormErrorsShow: 'price__promo-form__errors--show',
	orderFormErrorsShow: 'signup-form__errors--show',
	buttonLoading: 'button_type_submit_loading'
};

const hidePlaceholders = () => {
	const promoInput = $(selectors.promo.input);
	promoInput.focus( function () {
		$(this).data('placeholder', $(this).attr('placeholder'));
		$(this).attr('placeholder', '');
	});
	promoInput.blur( function () {
		$(this).attr('placeholder', $(this).data('placeholder'));
	});
};

const hidePromoErrorMessage = () => {
	$(selectors.promo.errors).removeClass(classes.promoFormErrorsShow);
};

const showPromoErrorMessage = message => {
	$(selectors.promo.errors).text(message).addClass(classes.promoFormErrorsShow);
};

const setPromoEventHandlers = () => {
	$(selectors.promo.link).on('click', function () {
		$(selectors.promo.wrap).slideToggle(500);
		$(selectors.promo.errors).text('').removeClass(classes.promoFormErrorsShow);
	});
	$(selectors.promo.form).on('submit', function (e) {
		e.preventDefault();
		hidePromoErrorMessage();
		const promocode = $('#promocode').val();
		$.ajax({
			url: '/check-promo',
			type: 'POST',
			data: {promo: promocode, mode: 'site', _csrf: $('meta[name="csrf-token"]').prop('content')},
			dataType: 'json',
			cache: false,
			success: result => {
				if (result.error) {
					showPromoErrorMessage(result.message);
				}
				else {
					result.discount = result.discount === 0 ? 1 : 1 - result.discount / 100;
					$('[data-price-discount]').each(function () {
						const discount = Math.round($(this).attr('data-price') * result.discount);
						$(this).attr('data-price-discount', discount);
					});
					$(selectors.promo.wrap).slideUp(500, function () {
						$(selectors.promo.link).hide();
						$(selectors.promo.apply).show();
					});
				}
			}
		});
	});
};

// const setTooltipHandlers = () => {
// 	const card = $(selectors.card.item);
// 	card.on('mousemove', function (event) {
// 		const tooltip = $(this).find(selectors.card.tooltip);
// 		tooltip.css({left: event.offsetX + 15, top: event.offsetY + 15, display: 'block'});
// 	}
// 	);
// 	card.on('mouseleave', function () {
// 		const tooltip = $(this).find(selectors.card.tooltip);
// 		tooltip.css('display', 'none');
// 	}
// 	);
// };

let loadingFlag = false;

const setOrderFormHandlers = () => {
	const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([A-Za-zА-Яа-яЁё\-0-9]+\.)+[A-Za-zА-Яа-яЁё]{2,}))$/;
	$(selectors.order.form).on('submit', function (e) {
		e.preventDefault();
		let hasFieldsError = false;
		const fieldErrorClass = $(e.target).attr('data-invalid-class');
		$(selectors.order.submit).addClass(classes.buttonLoading);
		$(selectors.order.errors).removeClass(classes.orderFormErrorsShow);

		let message = 'Пожалуйста, выберите тариф.';
		let tariffChoose = true;
		const orderData = {};

		$(selectors.order.inputs).each(function () {
			const name = $(this).attr('name');
			if (name === 'email') {
				if (!(emailRegex.test($(this).val()))) {
					$(this).addClass(fieldErrorClass);
					hasFieldsError = true;
				}
			}
			orderData[name] = $(this).val();
		});

		if (hasFieldsError) {
			$(selectors.order.submit).removeClass(classes.buttonLoading);
			return;
		}

		orderData.source = $('.select__item_state_selected').data('value');

		if ($(selectors.order.withoutTariff).length > 0) {
			tariffChoose = false;
		}
		if (tariffChoose) {
			orderData.packageName = $(selectors.card.tariff).data('package');
			if (orderData.packageName !== 'standard' && orderData.packageName !== 'business') {
				$(selectors.order.submit).removeClass(classes.buttonLoading);
				$(selectors.order.errors).html(message).addClass(classes.orderFormErrorsShow);
				return false;
			}
		} else {
			orderData.packageName = 'standard';
		}


		orderData.period = $('#period').val();
		orderData.enableMonthlyPayment = $('#enableMonthlyPayment').val();
		orderData.rubclient = $('#rubclient').val();
		orderData.totalamount = $(selectors.card.tariff).data('price');
		orderData.registration = 'n';
		orderData.orderMode = 'order';
		orderData.promoCode = $('#promocode').val();
		orderData.mailagree = 'y';
		orderData.discount = 'n';
		orderData.registerpage = typeof (orderData.registerpage) !== 'undefined' && orderData.registerpage ? orderData.registerpage : '';

		if (loadingFlag === false) {

			orderData.userIntercomId = '';
			if (window.Intercom !== 'undefined') { // eslint-disable-line
				orderData.userIntercomId = window.Intercom('getVisitorId'); // eslint-disable-line
			}

			$.ajax({
				url: '/send-site',
				type: 'POST',
				dataType: 'json',
				data: {
					name: orderData.name,
					lastname: orderData.lastname,
					email: orderData.email,
					source: orderData.source,
					packageName: orderData.packageName,
					period: orderData.period,
					enableMonthlyPayment: orderData.enableMonthlyPayment,
					rubclient: orderData.rubclient,
					totalamount: orderData.totalamount,
					registration: orderData.registration,
					orderMode: orderData.orderMode,
					mailagree: orderData.mailagree,
					discount: orderData.discount,
					promocode: orderData.promoCode,
					userIntercomId: orderData.userIntercomId,
					registerpage: orderData.registerpage,
					_csrf: $('meta[name="csrf-token"]').prop('content')
				}, xhrFields: {withCredentials: true},
				beforeSend: () => {
					$(selectors.order.preloader).show();
					loadingFlag = true;
				},
				success: response => {
					if (response.status !== 'ok') {
						$(selectors.order.submit).removeClass(classes.buttonLoading);
					}
					loadingFlag = false;
					switch (response.status) {
						case 'ok':
							/* eslint-disable */
							dataLayer.push({'event': 'regevent'});
							/* eslint-enable */
							window.location = response.location;
							break;
						case 'fail':
							message = 'Вы не являетесь клиентом хостинга от Gophotoweb. Пожалуйста, выберите другую опцию по услугам хостинга.';
							$(selectors.order.errors).html(message).addClass(classes.orderFormErrorsShow);
							break;
						case 'fail-upgrade':
							message = 'Вы не можете обновить сайт.';
							$(selectors.order.errors).html(message).addClass(classes.orderFormErrorsShow);
							break;
						case 'create-new-account':
							message = 'Пользователь с таким адресом электронной почты уже зарегистрирован. <a href="' + $('#clientarea').val() + '">Войти в свой аккаунт</a>.';
							$(selectors.order.errors).html(message).addClass(classes.orderFormErrorsShow);
							break;
						default:
							message = 'Ошибка при отправке заявки. Пожалуйста, заполните поля заявки еще раз и нажмите кнопку отправить.';
							$(selectors.order.errors).html(message).addClass(classes.orderFormErrorsShow);
							break;
					}
				},
				error: (qXHR, textStatus, errorThrown) => {
					loadingFlag = false;
					console.log('Order page error. XHR response text - ' + qXHR.responseText + ' XHR Status - ' + qXHR.status + '. Error status - ' + textStatus + '.  Error text - ' + errorThrown);
					$(selectors.order.submit).removeClass(classes.buttonLoading);
					message = 'Ошибка при отправке заявки. Пожалуйста, заполните поля заявки еще раз и нажмите кнопку отправить.';
					$(selectors.order.errors).html(message).addClass(classes.orderFormErrorsShow);
				},
				complete: (qXHR, textStatus) => {
					console.log(qXHR, textStatus);
					loadingFlag = false;
				}
			});
		}
	});
};

const render = () => {
	if (isElement(selectors.sectionQuestion)) {
		question();
		popup();
	}
	if (!isMobile.phone && !isMobile.tablet) {
		// setTooltipHandlers();
	}
	if (isElement(selectors.promo.section)) {
		hidePlaceholders();
		setPromoEventHandlers();
	}
	if (isElement(selectors.order.form)) {
		setOrderFormHandlers();
	}
};
export default render;



// WEBPACK FOOTER //
// ./app/blocks/price/price.js